import React from 'react';
import Typography from '@mui/material/Typography';
import Accordion from './Accordion';
import AccordionHeader from './AccordionHeader';
import { categoryLandingRoutesById, routerUrls } from 'constants';
import { subCategoryDisplayName } from '../utils/categoryLabels';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

// GOTOBED PRODUCT CATEGORIES FILTER ACCORDION
export default function AccordionMenu({ categoryList }) {
  return (
    <>
      {categoryList?.map((category) => (
        <Accordion
          key={category.name_bg}
          expanded
          sx={{
            mb: 2,
            borderRadius: 2,
            boxShadow: 'none',
            border: '1px solid',
            borderColor: 'divider',
            overflow: 'hidden',
            background: '#fff'
          }}>
          <AccordionHeader px={0} py={1.25} color="text.primary">
            <Typography
              sx={{
                cursor: 'pointer',
                mr: '9px',
                fontWeight: 600,
                fontSize: 17,
                color: 'gold.text',
                letterSpacing: 0.2
              }}>
              {category.name_bg}
            </Typography>
          </AccordionHeader>
          {categoryLandingRoutesById[category.id] && (
            <Link
              style={{ color: 'inherit', textDecoration: 'none' }}
              to={categoryLandingRoutesById[category.id]}>
              <Typography
                fontSize="15px"
                pl="28px"
                py={1}
                sx={{ cursor: 'pointer', fontWeight: 600, color: 'gold.text' }}>
                Всички категории
              </Typography>
            </Link>
          )}
          {category?.subCategories?.map((subCategory, idx) => (
            <Link
              style={{ color: 'inherit', textDecoration: 'none' }}
              to={
                routerUrls.products +
                '/' +
                category.slug_bg +
                '/' +
                subCategory.slug_bg +
                '/' +
                category.id +
                '/' +
                subCategory.id
              }
              key={subCategory.id}>
              <Typography
                key={idx}
                fontSize="15px"
                color="text.secondary"
                pl="28px"
                py={1}
                sx={{
                  cursor: 'pointer',
                  borderRadius: 1,
                  transition: 'color 0.2s',
                  background: '#fff',
                  '&:hover': {
                    color: 'gold.text',
                    background: '#fff'
                  }
                }}>
                {subCategoryDisplayName(subCategory.name_bg)}
              </Typography>
            </Link>
          ))}
        </Accordion>
      ))}
    </>
  );
}

AccordionMenu.propTypes = {
  categoryList: PropTypes.array
};
